<template>
    <v-row>
        <v-col
            md="4"
            offset-md="4"
        >
            <v-card>
                <v-card-title class="primary--text">
                    Autenticação
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        @submit.prevent="enviarSolicitacao"
                    >
                        <v-text-field
                            v-model="form.EMAIL"
                            label="E-mail"
                            type="email"
                            :rules="[$rules.required, $rules.email]"
                        />
                        <v-text-field
                            v-model="form.SENHA"
                            label="Senha"
                            type="password"
                            :rules="[$rules.required]"
                        />

                        <v-layout justify-center>
                            <v-btn
                                color="primary"
                                type="submit"
                            >
                                Login
                            </v-btn>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import { VMoney } from 'v-money';
    import api from '../../services/api';

    export default {
        directives: { money: VMoney },
        data() {
            return {
                form: {
                    EMAIL: null,
                    SENHA: null
                }
            };
        },

        methods: {
            async enviarSolicitacao() {
                try {
                    if (this.$refs.form.validate()) {
                        const response = await api.login(this.form);

                        localStorage.setItem('USER', JSON.stringify(response.data));

                        this.$root.user = response.data;

                        this.$router.push('/');
                        this.$refs.form.reset();
                    }
                } catch (error) {
                    this.$root.$emit('message', { text: 'Erro ao realizar login.', color: 'error' });
                }
            }
        }
    };
</script>